import type { CSSProperties, ReactNode } from "react";
import { SoundButton, type SoundButtonProps } from "../SoundButton/SoundButton";
import "./ButtonVar1.scss";

export interface ButtonVar1Colors {
    containerStroke?: string;
    containerFill?: string;
    faceStroke?: string;
    faceFill?: string;
}

export interface ButtonVar1Props extends Omit<
    SoundButtonProps,
    "children" | "content"
> {
    text?: string;
    content?: ReactNode;
    padding?: CSSProperties["padding"];
    colors?: ButtonVar1Colors;
}

interface ButtonVar1CustomProperties extends CSSProperties {
    "--button-var-1-container-stroke"?: string;
    "--button-var-1-container-fill"?: string;
    "--button-var-1-face-stroke"?: string;
    "--button-var-1-face-fill"?: string;
}

export function ButtonVar1({
    text,
    content,
    className,
    padding,
    colors,
    style,
    type = "button",
    ...buttonProps
}: ButtonVar1Props) {
    const buttonStyle: ButtonVar1CustomProperties = {
        ...style,
        ...(colors?.containerStroke !== undefined && {
            "--button-var-1-container-stroke": colors.containerStroke,
        }),
        ...(colors?.containerFill !== undefined && {
            "--button-var-1-container-fill": colors.containerFill,
        }),
        ...(colors?.faceStroke !== undefined && {
            "--button-var-1-face-stroke": colors.faceStroke,
        }),
        ...(colors?.faceFill !== undefined && {
            "--button-var-1-face-fill": colors.faceFill,
        }),
    };

    return (
        <SoundButton
            {...buttonProps}
            type={type}
            className={["button-var-1", className].filter(Boolean).join(" ")}
            style={buttonStyle}
        >
            <span
                className="button-var-1__face"
                style={padding === undefined ? undefined : { padding }}
            >
                {content !== undefined ? (
                    content
                ) : text !== undefined ? (
                    <span className="button-var-1__text">{text}</span>
                ) : null}
            </span>
        </SoundButton>
    );
}
